module.exports = __webpack_public_path__ + "static/media/hero-6.09eabd75.jpg";